export const initialState = {
  isLoading: false,
  billingActivityCpiData: [],
  isDataFound: false,
  billingCPITotalCount: 0,
  //Billing Activity -> Billing Tab Grid
  isBillingDataLoading: false,
  isBIllingDataFound: false,
  billingActivityBillingData: [],
  billingActivityBillingTotalCount: 0,
};
